import { Modal } from "bootstrap"

function getModalInstance(id) {
  const element = document.getElementById(id)
  if (!element) return null
  return Modal.getOrCreateInstance(element)
}

export default {
  install(app) {
    const bvModal = {
      show(id) {
        const instance = getModalInstance(id)
        if (instance) {
          instance.show()
        }
      },
      hide(id) {
        const instance = getModalInstance(id)
        if (instance) {
          instance.hide()
        }
      },
      toggle(id) {
        const instance = getModalInstance(id)
        if (!instance) return

        const element = document.getElementById(id)
        if (element?.classList.contains("show")) {
          instance.hide()
        } else {
          instance.show()
        }
      },
      msgBoxConfirm(message, options = {}) {
        const title = options.title ? `${options.title}\n\n` : ""
        const response = window.confirm(`${title}${message}`)
        return Promise.resolve(response)
      },
      hideAll() {
        document.querySelectorAll(".modal.show").forEach((element) => {
          const instance = Modal.getInstance(element)
          instance?.hide()
        })
      },
      cleanup() {
        document.querySelectorAll(".modal-backdrop").forEach((element) => {
          element.remove()
        })
        document.body.classList.remove("modal-open")
        document.body.style.removeProperty("padding-right")
        document.body.style.removeProperty("overflow")
        document.documentElement.style.removeProperty("overflow")
      },
    }

    app.config.globalProperties.$bvModal = bvModal
  },
}
